<template>
  <div>
    <div class="col-sm-12 col-xs-12 col-md-12 box-wrapper pl-24">
      <div class="col-sm-12 col-xs-12 col-md-12 p-0">
        <hr />
      </div>
      <div id="body" class="col-sm-6 col-md-6 col-xs-12 changepassword_wrapper pl-0">
        <div class="row">
          <div class="col-xs-12 col-sm-12">
            <div class="col-xs-12 col-sm-12 label_name">{{$t('currentPassword')}} <span class="required">*</span></div>
            <div class="col-xs-12 col-sm-12 field_css">
              <input
                type="password"
                id="currentPassword"
                class="form-control"
                :placeholder="$t('confirmPassword')"
                v-model="password.current"
              />
              <span>
                <img v-if="showCurrentPassword"
                      src="/static/images/icons/redesign-eye.svg"
                      alt="eye-image"
                      id="togglePassword"
                      @click="switchCurrentVisibility()"
                    />
                <img v-if="!showCurrentPassword"
                  src="/static/images/icons/eye-slash-icon.svg"
                  alt="eye-slash-image"
                  id="togglePassword"
                  @click="switchCurrentVisibility()"
                />
              </span>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12">
            <div class="col-xs-12 col-sm-12 label_name">{{$t('newPassword')}} <span class="required">*</span></div>
            <div class="col-xs-12 col-sm-12 field_css">
               <input
                type="password"
                class="form-control"
                :placeholder="$t('newPassword')"
                v-model.trim="password.newPassword"
                @input="validate"
                id="newPassword"
              />
              <span>
                <img v-if="showNewPassword"
                  src="/static/images/icons/redesign-eye.svg"
                  alt="eye-image"
                  id="togglePassword"
                  @click="switchNewVisibility()"
                />
                <img v-if="!showNewPassword"
                  src="/static/images/icons/eye-slash-icon.svg"
                  alt="eye-slash-image"
                  id="togglePassword"
                  @click="switchNewVisibility()"
                />
              </span>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12">
            <div class="col-xs-12 col-sm-12 label_name">{{$t('confirmPassword')}} <span class="required">*</span></div>
            <div class="col-xs-12 col-sm-12 field_css">
              <input
                type="password"
                class="form-control"
                :placeholder="$t('confirmPassword')"
                v-model.trim="password.reTypeNewPassword"
                @input="validate"
                id="confirmPassword"
              />
              <span>
                <img v-if="showConfirmPassword"
                  src="/static/images/icons/redesign-eye.svg"
                  alt="eye-image"
                  id="togglePassword"
                  @click="switchConfirmVisibility()"
                />
                <img v-if="!showConfirmPassword"
                  src="/static/images/icons/eye-slash-icon.svg"
                  alt="eye-slash-image"
                  id="togglePassword"
                  @click="switchConfirmVisibility()"
                />
              </span>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 validation-message pl-30 pr-0" v-if="password.newPassword && PasswordError">
            {{PasswordError}}
          </div>
          <div class="col-xs-12 col-sm-12" v-if="changePasswordError.length">
            <div
              class="col-xs-12 col-sm-12 validation-message"
            >{{changePasswordError}}</div>
          </div>
        </div>
      </div>
      <div class="footer col-xs-12 col-sm-12 d-flex-sm-end">
        <div class="xs-pd-lt-0">
          <button
            type="button"
            class="btn cancel_button"
            data-dismiss="modal"
            @click="$emit('closepopup')"
          >{{$t('cancel')}}</button>
        </div>
        <div class="xs-pd-lt-0 xs-pd-rt-0">
          <button
            type="button"
            class="btn save_changes_button"
            @click="updatePassword"
            :disabled="!password.current || !password.newPassword || !password.reTypeNewPassword || loaderStatus || (password.newPassword !== password.reTypeNewPassword) || PasswordError"
          >{{$t('saveChanges')}}</button>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import Loader from '../UIComponents/Loader.vue';
import { changePassword } from '../../apis/passwords';
import {
  isContainsUpperCase,
  isContainsLowerCase,
  isContainsDigit,
  isContainsSpecialChar,
  checkConditions,
} from '../Register/validator';

export default {
  components: {
    Loader,
  },
  props: ['roleId'],
  data() {
    return {
      showNewPassword: true,
      showCurrentPassword: true,
      showConfirmPassword: true,
      loaderStatus: false,
      password: {
        current: '',
        newPassword: '',
        reTypeNewPassword: '',
      },
      PasswordError: false,
      changePasswordError: [],
      verification: [
        { message: 'Have at least one capital letter', valid: false },
        { message: 'Have at least one lowercase letter', valid: false },
        { message: 'Have at least one number', valid: false },
        { message: 'Have at least one special character', valid: false },
      ],
    };
  },
  computed: {
  },
  methods: {
    switchCurrentVisibility() {
      this.showCurrentPassword = !this.showCurrentPassword;
      const resetPasswordField = document.querySelector('#currentPassword');
      if (resetPasswordField.getAttribute('type') === 'password') {
        resetPasswordField.setAttribute('type', 'text');
      } else {
        resetPasswordField.setAttribute('type', 'password');
      }
    },
    switchNewVisibility() {
      this.showNewPassword = !this.showNewPassword;
      const resetPasswordField = document.querySelector('#newPassword');
      if (resetPasswordField.getAttribute('type') === 'password') {
        resetPasswordField.setAttribute('type', 'text');
      } else {
        resetPasswordField.setAttribute('type', 'password');
      }
    },
    switchConfirmVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
      const resetPasswordField = document.querySelector('#confirmPassword');
      if (resetPasswordField.getAttribute('type') === 'password') {
        resetPasswordField.setAttribute('type', 'text');
      } else {
        resetPasswordField.setAttribute('type', 'password');
      }
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },

    validate() {
      this.counter = 0;
      if (this.password.newPassword) {
        this.verification[0].valid = isContainsUpperCase(
          this.password.newPassword,
        );
        this.verification[1].valid = isContainsLowerCase(
          this.password.newPassword,
        );
        this.verification[2].valid = isContainsDigit(this.password.newPassword);
        this.verification[3].valid = isContainsSpecialChar(
          this.password.newPassword,
        );
      }
      this.counter = checkConditions(this.password.newPassword);
      this.isPasswordLength = false;
      if (this.password.newPassword.length >= 10) this.isPasswordLength = true;
      const text = 'Sua senha deve ter pelo menos 10 caracteres e atender a 3 destes 4 critérios: 1 letra maiúscula (A-Z), 1 letra minúscula ( a-z), 1 número (1-9) e um caractere especial (!@#$., +=( )_%^&*)';
      this.PasswordError = this.$i18n.locale === 'Portuguese' ? text : 'Your password must be at least 10 characters and meet any 3 of these 4 criteria: 1 capital letter (A-Z), 1 lowercase letter ( a-z), 1 number (1-9), and one special character (!@#$.,+=( )_%^&*)';
      if (this.isPasswordLength && this.counter >= 3) {
        if (this.password.reTypeNewPassword && this.password.newPassword !== this.password.reTypeNewPassword) {
          this.PasswordError = this.$i18n.locale === 'Portuguese' ? 'A senha de confirmação não corresponde à nova senha acima' : 'The confirm password doesn\'t match the new password above';
        } else {
          this.PasswordError = false;
        }
      }
    },

    async updatePassword() {
      this.loaderStatus = true;
      const data = {
        currentPassword: this.password.current,
        newPassword: this.password.newPassword,
      };
      const response = await changePassword(data);
      if (!response) {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: response.message,
          group: 'custom-notification',
        });
      } else if (response && !response.status) {
        this.changePasswordError = response.message;
      } else {
        this.changePasswordError = [];
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: response.message,
          group: 'custom-notification',
        });
        this.passwordFlag = false;
        this.unsetPasswordFlag();
      }
      this.loaderStatus = false;
    },
    unsetPasswordFlag() {
      this.password = { current_password: '', new_password: '', confirm_password: '' };
      this.passwordFlag = false;
      this.changePasswordError = '';
      this.$emit('emitBreadCrumb', false);
    },
  },
  filters: {
  },
  mounted() {
    this.password.current_password = '';
  },
};
</script>

<style scoped>
#togglePassword{
  cursor: pointer;
  float: right;
  position: absolute;
  bottom: 10px;
  right: 16px;
}
.label_name {
  font-size: 16px;
  color: #3e3e3e;
  padding: 0px;
  font-weight: 400;
  line-height: 19px;
}
.required {
  color: #C02032;
  font-size: 12px;
  position: relative;
  top: -3px;
}
.footer {
  padding-top: 10px;
  position: fixed;
  bottom: 0%;
  padding-right: 24px;
  padding-bottom: 2%;
  right: 0;
  background-color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.form-control {
  padding: 6px 12px !important;
  border: 1px solid #686E73;
  height: 40px;
  color: #4d4d4d;
}
.field_css {
  padding: 0px;
  margin-bottom: 3%;
}
.add_icon_img {
  padding-bottom: 3px;
}
.fnt_14{
  font-size: 14px;
}
.alert-image{
  background-image: url(/static/images/icons/alert_triangle.svg);
  background-repeat: no-repeat;
  background-position-y: center;
  content: "";
  width: 50px;
  height: 57px;
  position: relative;
  background-size: 40px;
}
.position-relative {
  position: relative;
}
.min_hght_32 {
  min-height: 32px;
}
.min-ht-100 {
  min-height: 100px;
}
.renew-class {
  color: #00518a;
  position: absolute;
  right: 45px;
  top: -4px;
  text-align: center;
}
.renew-class-2 {
  top: -35px;
}
.top_28 {
  top: 28px;
}
.pr-40 {
  padding-right: 40px !important;
}
.display-flex{
  display: -webkit-box;
  align-items: center;
}
.ft-16{
  font-size:16px;
}
.pt-10 {
  padding-top: 10px;
}
.cust-link {
  margin-top: 5px;
  color: #2f80ed;
  font-size: 14px;
  cursor: pointer;
}
.market_place_img {
  width: 18%;
  margin-top: 7%;
}
.ml-5 {
  margin-left: 5px;
}
.m-0 {
  margin: 0;
}
.pl-25 {
  padding-left: 25px;
}
.p-0 {
  padding: 0;
}
.main-add-services {
  top: 54px;
  right: 47px;
  position: absolute;
}
img.success_logo.card-img-top {
    width: 30px;
    height: 30px;
    background-color: #00518a;
    border-radius: 50%;
    padding: 6px;
}
.cancel-services,
.upgrade-service,
.renew-service {
  text-align: end;
  margin-right: 32px;
}
.upgrade-service {
  margin-bottom: 20px;
  margin-top: 6px;
}
.cancel-services {
  color: #00518a;
  cursor: pointer;
  /* margin-right: 45px; */
}
.dollar-year {
  text-align: end;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
}
.box-wrapper {
  overflow-y: auto;
  max-height: calc( 84vh - 100px );
  overflow-x: hidden;
  padding-bottom: 100px;
}
ul.regulatory-intelligence {
  list-style: none;
  padding-left: 0px;
}
.box-wrapper hr.upper-line {
  margin: 7px 32px 9px 0px;
}
.box-wrapper hr.upper-line-records {
  margin: 9px 32px 13px 53px;
}

.team-member-reg,
.registration-records {
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  padding-bottom: 4px;
}
.registration-records {
  padding-bottom: 9px;
}
span.available-item {
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.7);
}

span.total-record {
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
}
.reg-tracker-service {
  font-size: 20px;
  text-align: center;
  color: #000000;
  padding-top: 10px;
}
.confirm-body .reg-tracker-para {
  padding-bottom: 5px;
}
.acct-service {
  font-weight: 300;
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
  padding-left: 10px;
}
.team-members {
  padding-left: 40px;
}
.available-upto {
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
}
.check-icon {
  padding-right: 12px;
}
.free-renews {
  padding-top: 9px;
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  line-height: 19px;
}
.country_list {
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
}
.mb-5 {
  margin-bottom: 5px;
}
.upper-line-services {
  margin: 12px 32px 12px 0px;
}
.reg-records,
.free-service-renews {
  padding-left: 25px;
}
.pt-20 {
  padding-top: 20px;
}
@media only screen and (max-width: 767px) {
  .renew-class {
    right: 15px;
  }
  .free-renews {
    padding-bottom: 15px;
  }
  .ml-5{
    margin-left: -15px;
  }
  .main-add-services {
    right: 15px;
  }
  .upgrade-service-btn{
    text-align: start;
  }
  .upgrade-service,
  .renew-service,
  .upper-line-services,
  .cancel-services {
    margin-right: 0px;
  }
  ul.regulatory-intelligence {
    padding-left: 0px;
  }
  .acct-service {
    padding-top: 8px;
  }
  .box-wrapper hr.upper-line {
    margin-right: 0px;
    margin-top: 10px;
  }
  .dollar-year {
    text-align: center;
  }
  .box-wrapper .reg-tracker {
    margin-left: 0px;
  }
}
@media (min-width: 767px) and (max-width: 1024px) {
  .box-wrapper {
    max-height: 46vh;
  }
}
@media screen and (width: 768px) {
  .box-wrapper {
    max-height: 52vh;
  }
}
@media (min-width: 1422px) and (max-width: 1599px) {
  .free-service-renews {
    padding-left: 15px;
  }
  .reg-records {
    padding-left: 15px;
  }
}
@media only screen and (min-width: 1600px) {
  .free-service-renews {
    padding-left: 4px;
  }
  .reg-records {
    padding-left: 4px;
  }
}
/* Modal */
.modal-header .close {
  background: none;
  opacity: 0.5;
  height: 17px;
  line-height: 17px;
  color: #828282;
  width: 17px;
  border-radius: 20px;
  font-weight: 300;
  outline: none;
  font-size: 32px;
}
.modal-header.cancelModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.confirm-body {
  padding: 5% 12%;
  margin-bottom: 10%;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
}
.modal-footer.cancelModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.modal-footer.cancelModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.submit-btn {
  background: #0b3c61;
  border: 1px solid #0b3c61;
  box-sizing: border-box;
  border-radius: 20px;
  color: #f2f2f2;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  padding: 7px 41px 11px;
}
.upgrade-service a,
.cancel-services a {
  cursor: pointer;
}

.modal-content.first-modal-content {
  border-radius: 12px;
}
.cancel-service-para {
  font-size: 18px;
  text-align: center;
  color: #000000;
  padding-top: 10px;
}
.reg-intelligence-para {
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #0b3c61;
  padding-top: 10px;
}
.modal-body-para {
  padding: 5px 55px;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #828282;
}
.current-service {
  background: #0b3c61;
  border: 1px solid #0b3c61;
  box-sizing: border-box;
  border-radius: 20px;
  color: #f2f2f2;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  padding: 8px 38px;
}
.please-cancel {
  background: #fff;
  border: 1px solid #0b3c61;
  box-sizing: border-box;
  border-radius: 20px;
  color: #0b3c61;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  padding: 8px 60px;
}
.modal-footer.cancelModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
  padding-bottom: 32px;
}

.modal-title.service-modal-title {
  text-align: center;
}
.cancel-successful {
  padding-top: 16px;
  font-weight: 500;
  font-size: 28px;
  line-height: 33px;
  color: #4c9e45;
}
.process-cancel {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #828282;
  padding-top: 16px;
}
.scnd-modal-service {
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #133d5f;
}
.process-hr-line {
  margin-bottom: 0px;
}
.modal-header.scnd-cancelModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
  padding-bottom: 0px;
}
.scnd-service-para {
  padding: 6px 121px;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
}
.textarea-field {
  text-align: center;
}
.textarea-field textarea {
  background: #ffffff;
  border: 0.5px solid #828282;
  box-sizing: border-box;
  border-radius: 7px;
}
div#cancelModal {
  background-color: rgba(0, 0, 0, 0.5);
}
div#scnd-cancelModal {
  background-color: rgba(0, 0, 0, 0.9);
}
/* upgrade modal */
div#upgradeModal {
  background-color: rgba(0, 0, 0, 0.5);
}
div#ConfirmationModal {
  background-color: rgba(0, 0, 0, 0.6);
}
.modal-header.upgradeModal-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.upgrade-service-para {
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #0b3c61;
  padding-top: 10px;
}
.reg-tracker-para {
  font-size: 18px;
  text-align: center;
  color: #000000;
  padding-top: 10px;
}
.form-control::placeholder{
  font-weight: 300;
  font-size: 16px;
  line-height: 25px !important;
  color: #4d4d4d;
}
.custom-dropdown
  >>> .multiselect__content-wrapper
  .multiselect__option--highlight,
.consultant_dropdown
  >>> .multiselect__content-wrapper
  .multiselect__option--highlight {
  color: #000000;
  height: 30px;
  background: #f5f5f5;
}

.multiselect--active.custom-dropdown >>> .multiselect__select:before {
  top: 5px;
}
.custom-dropdown >>> .multiselect__option--selected:before,
.consultant_dropdown >>> .multiselect__option--selected:before {
  content: "\f00c";
  font-family: FontAwesome;
  font-style: normal;
  font-weight: normal;
  text-decoration: inherit;
  color: green;
  float: right;
}
.custom-dropdown >>> .multiselect__tags {
  border-radius: 20px;
  min-height: 0;
  font-weight: 500;
  border: 1px solid #000000;
  color: #0b3c61;
  height: 35px;
  line-height: 11px;
}
.custom-dropdown >>> .multiselect__placeholder {
  padding-top: 4px;
}
.custom-dropdown >>> .multiselect__content-wrapper {
  min-height: 0px;
  max-height: 180px !important;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 10px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.custom-dropdown.multiselect--active::before {
  content: "";
  -webkit-box-shadow: -1px -1px 10px -2px rgba(0, 0, 0, 0.5);
  box-shadow: 3px -2px 6px -4px rgba(0, 0, 0, 0.5);
  position: absolute;
  right: 10px;
  top: 30px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  width: 20px;
  height: 20px;
  background: white;
}
.custom-dropdown.multiselect--active.multiselect--above::before {
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
  top: -15px;
}
.custom-dropdown.multiselect--above >>> .multiselect__content-wrapper {
  box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.25);
}
.custom-dropdown >>> .multiselect__select:before,
.consultant_dropdown >>> .multiselect__select:before {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  border: 1px solid #0b3c61;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 4px;
  top: 0;
  content: "";
}
.consultant_dropdown >>> .multiselect__select:before {
  top: 5px;
}
p.inline-service {
  display: inline;
}
.traingle-alert {
  margin-right: 10px;
  width: 20px;
  vertical-align: bottom;
}
.expiration-title {
  color:#B00505;
  vertical-align: bottom;
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px){
  .box-wrapper {
    max-height: 60vh;
    padding-bottom: 11px
  }
}
/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px){
  .box-wrapper {
    max-height: 55vh;
    padding-bottom: 11px
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px), (device-width: 667px) and (device-height: 375px){
  .box-wrapper {
    max-height: 60vh;
    padding-bottom: 11px
  }
}
.alert-image .tooltiptext {
  visibility: hidden;
  width: 351px;
  background-color: #F2F2F2;
  color: rgba(0, 0, 0, 0.7);
  text-align: center;
  border-radius: 10px;
  padding: 16px;
  position: absolute;
  z-index: 1;
  top: 3.8em;
  left: -1em;
  margin-left: -60%;
  opacity: 0;
  transition: opacity 1s;
  box-shadow: 8px 4px 10px rgba(0, 0, 0, 0.5);
  font-size: 18px;
  line-height: 21px;
  font-weight: 400;
  text-align: left;
  word-break: break-word;
}
.alert-image:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
.alert-image .tooltiptext::after {
  display: unset;
  position: absolute;
  pointer-events: none;
  content: "";
  transform: rotate(45deg);
  width: 1em;
  height: 1em;
  background: #F2F2F2;
  z-index: -10;
  top: -0.4em;
  left: 3.4em;
  box-shadow: none;
  margin: auto;
}
</style>
